export default __webpack_public_path__ + "static/tour-de-france-04c37199581659067beefbf375267823.jpg";